import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom"; 
import { logout } from "../../services/operations/authAPI"; 
import pstvue from "../../asstes/pstvue.png"
import { useTranslation } from "react-i18next";

export default function ChatNavbar() {
  const { t } = useTranslation();
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const user = useSelector((state) => state.profile?.user);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const getInitials = (name) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map((n) => n.charAt(0).toUpperCase())
      .join("")
      .slice(0, 2);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="p-4 text-xl font-semibold border-b border-gray-700 flex justify-between items-center w-full">
      {/* Left Section - Logo + App Name */}
      <div className="items-center">
      <Link to = "/dashboard">
        <img
          src={pstvue}
          alt="Logo"
          className="w-40 h-10 object-contain"
        />
      </Link>
        {/* <span className="text-base sm:text-lg font-medium text-[#b0fffb]">
          Student Ai Tutor
        </span> */}
      </div>

      {/* Right Section - Profile Dropdown */}
      <div className="flex items-center gap-4 relative" ref={dropdownRef}>
        <button
          className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 hover:ring-2 hover:ring-blue-500 text-white"
          onClick={() => setDropdownOpen((prev) => !prev)}
        >
          {getInitials(user?.name)}
        </button>

        {dropdownOpen && (
          <div className="absolute top-14 right-0 bg-gray-800 border border-gray-700 rounded-md shadow-lg w-40 z-50">
            <Link
              to="/dashboard/profile"
              className="block px-4 py-2 text-sm hover:bg-gray-700"
            >
               {t("navbar.profile")}
            </Link>
            <button
              onClick={() => {
                setDropdownOpen(false);
                dispatch(logout(navigate)); // 🔁 Use navigate
              }}
              className="w-full text-left px-4 py-2 text-sm hover:bg-gray-700"
            >
                {t("navbar.logout")}
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
